import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CiUser, CiLock } from "react-icons/ci";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { bindActionCreators } from 'redux';
import * as yup from 'yup';
import { Crypt } from 'hybrid-crypto-js';
import * as loginAction from '../redux/actions/authAction';
import toast, { Toaster } from 'react-hot-toast';
import { Checkbox, Form, Input } from '@heroui/react';
import { Button } from '@heroui/button';
import OgLogo from '../assets/ogOgLogo.png';
import spinner from '../assets/tube-spinner.svg';

// Schema validation with Yup
const schema = yup.object({
    email: yup.string().email('Invalid email address').required('Email is required'),
    password: yup.string().min(6, 'Password should be at least 6 characters').required('Password is required'),
}).required();


function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { login } = bindActionCreators(loginAction, dispatch);

    const [showPassword, setShowPassword] = useState(false);
    const toggleVisibility = () => setShowPassword(!showPassword);
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });


    // Handle form submission
    const onSubmit = async (data) => {
        setLoading(true);
        try {
            let crypt = new Crypt();
            const encryptedPassword = crypt.encrypt(process.env.REACT_APP_ENCRYPT_KEY, data.password);
            const encryptedData = { ...data, password: encryptedPassword, rememberMe };

            const res = await login(encryptedData);

            if (res?.error) {
                console.error("Login Failed:", res.message);
                toast.error(res.message);
            } else {
                toast.success(res.message);
                setTimeout(() => {
                    navigate("/dashboard");
                }, 2000);
            }
        } catch (error) {
            toast.error('Login failed please try again later!');
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className=" flex justify-center items-center h-screen bg-gradient-to-b from-gradiant1 to-gradiant2">
            {/* Left: Image */}


            {/* Right: Login Form */}
            <div className="mx-auto w-full flex justify-center items-center custom-bg lg:p-36 md:p-10 sm:20 p-8">

                <div className='w-full max-w-xl bg-white p-16 flex flex-col justify-center items-center shadow-global rounded-global'>
                    <img
                        src={OgLogo}
                        alt="Placeholder Image"
                        className="object-cover w-20 h-20"
                    />
                    <h1 className="text-3xl m-0  font-bold pt-2 pb-10">Sign in to your account</h1>
                    <Form onSubmit={handleSubmit(onSubmit)} className="w-full flex flex-colspace-y-6">

                        <div className="flex flex-col gap-8 w-full">
                            {/* Email Input */}
                            <Input
                                {...register('email')}
                                label="Email"
                                name="email"
                                labelPlacement='outside'
                                placeholder="Enter your email."
                                type="email"
                                classNames={{ inputWrapper: "rounded-lg border-gray-500 focus:outline-none" }}
                                className='rounded-lg'
                                size="lg"
                                variant='bordered'
                                startContent={
                                    <CiUser className='text-2xl text-gray-400' />
                                }
                                isInvalid={errors.email ? true : false}
                                errorMessage={errors.email && errors.email.message}
                            />
                            <Input
                                {...register('password')}
                                label="Password"
                                name="password"
                                labelPlacement='outside'
                                placeholder="Enter your password."
                                type={showPassword ? "text" : "password"}
                                classNames={{ inputWrapper: "rounded-lg border-gray-500 focus:outline-none" }}
                                className='rounded-lg'
                                size="lg"
                                variant='bordered'
                                startContent={
                                    <CiLock className='text-2xl text-gray-400' />
                                }
                                endContent={
                                    <button
                                        type="button"
                                        onClick={toggleVisibility}
                                        className="focus:outline-none"
                                    >
                                        {showPassword ? <FaRegEyeSlash className="text-2xl text-gray-500" /> : <FaRegEye className="text-2xl text-gray-500" />}
                                    </button>
                                }
                                isInvalid={errors.password ? true : false}
                                errorMessage={errors.password && errors.password.message}
                            />
                        </div>

                        {/* Remember Me Checkbox */}
                        <div className="flex w-full flex-row justify-between items-center  pt-1 pb-5">
                            <Checkbox
                                classNames={{ icon: 'text-black' }}
                                color="hover"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                            >
                                Remember Me
                            </Checkbox>
                            <NavLink to="/forgot-password" className="text-orange-700 hover:text-secondary-600">Forgot Password?</NavLink>
                        </div>

                        {/* Login Button */}
                        <Button type="submit" className="w-full py-2 px-4 bg-primary hover:bg-hover text-black font-semibold rounded-md flex flex-row-reverse change-svgcolor">
                            {loading ? <><img src={spinner} alt="" />Logging in..</> : "Login"}
                        </Button>
                    </Form>
                </div>
                <Toaster
                    position="top-right"
                    reverseOrder={false}
                />
            </div>
        </div>
    );
}

export default Login;